import { render, staticRenderFns } from "./AboutGreetingPage.vue?vue&type=template&id=1f3aa5ac&scoped=true"
import script from "./AboutGreetingPage.vue?vue&type=script&lang=js"
export * from "./AboutGreetingPage.vue?vue&type=script&lang=js"
import style0 from "./AboutGreetingPage.vue?vue&type=style&index=0&id=1f3aa5ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3aa5ac",
  null
  
)

export default component.exports